export enum LocationType {
  AIRPORT = 'airport',
  CITY = 'city',
  COUNTRY = 'country',
}

export interface IAirport {
  type: LocationType.AIRPORT;
  iataCode: string;
  airportName: string;
  airportNameEn: string;
  cityCode: string;
  cityName: string;
  cityNameEn: string;
  countryCode: string;
  countryName: string;
  countryNameEn: string;
  isDomestic: boolean;
  event: boolean;
}

export interface ICity {
  type: LocationType.CITY;
  iataCode: string;
  cityName: string;
  cityNameEn: string;
  countryCode: string;
  countryName: string;
  countryNameEn: string;
  isDomestic: boolean;
  event: boolean;
}

export interface ICountry {
  type: LocationType.COUNTRY;
  countryCode: string;
  countryName: string;
  countryNameEn: string;
}

export type TLocation = IAirport | ICity | ICountry;
